import axios from "axios";

// Connected to the LIVE Nikah Match production backend (same accounts as Android/iOS).
// Auth is Bearer-token (no cookies). Token persisted in localStorage.
export const API = process.env.REACT_APP_PROD_API_URL;
const TOKEN_KEY = "nikah_token";

if (!API && typeof window !== "undefined") {
  // eslint-disable-next-line no-console
  console.error("[Nikah Match] REACT_APP_PROD_API_URL is not set — the frontend must be rebuilt after editing .env so the production API URL is embedded in the bundle.");
}

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
